import { combineReducers } from 'redux';
import registrationPopupReducer from '../components/RegistrationPopup/redux/registrationPopupActions';
import signInPopupReducer from '../components/SignInPopup/redux/signInPopupActions';
import appReducer from '../components/App/redux/AppActions';
import cartReducer from '../components/CartPage/redux/cartPageActions';
import cart2Reducer from '../components/Cart/redux/cartActions';
import search2Reducer from '../components/Search/redux/searchActions';
import searchReducer from './searchActions';
import catalogReducer from './catalogActions';
import categoriesReducer from './categoriesActions';
import userReducer from '../components/User/redux/userAction';
import toCartPopupReducer from '../components/ToCartPopup/redux/toCartPopupActions';

import supplierReducer from '../components/Supplier/redux/supplierAction';


const rootReducer = combineReducers({
  appReducer,
  registrationPopupReducer,
  signInPopupReducer,
  cartReducer,
  cart2Reducer,
  searchReducer,
  search2Reducer,
  catalogReducer,
  categoriesReducer,
  toCartPopupReducer,
  userReducer,
  supplierReducer
});

export default rootReducer;




/** WEBPACK FOOTER **
 ** ./src/redux/index.js
 **/